var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdviserReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4996 33.5L26.5 30.4992L27.1068 29.8931L29.0711 31.8585V27.5H29.9289V31.8577L31.8932 29.8931L32.5 30.4992L29.4996 33.5Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F4F4F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 38C25.3647 38 22 34.6353 22 30.5C22 26.3647 25.3647 23 29.5 23C33.6353 23 37 26.3647 37 30.5C37 34.6353 33.6353 38 29.5 38ZM29.5 23.6894C25.745 23.6894 22.6901 26.7443 22.6901 30.4992C22.6901 34.2542 25.745 37.3091 29.5 37.3091C33.255 37.3091 36.3099 34.2542 36.3099 30.4992C36.3099 26.7443 33.255 23.6894 29.5 23.6894Z",
    fill: "#F4F4F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27H21",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    stroke: "#F4F4F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H23",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    stroke: "#F4F4F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21H29",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    stroke: "#F4F4F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 30H20",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    stroke: "#F4F4F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 33H20",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    stroke: "#F4F4F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3265 38H8.38344C7.34486 38 6.5 37.1451 6.5 36.0942V3.90588C6.5 2.85492 7.34486 2 8.38344 2H31.6166C32.6552 2 33.5 2.85492 33.5 3.90588V24.2512C33.5 24.4449 33.3455 24.6013 33.1541 24.6013C32.9626 24.6013 32.8081 24.4449 32.8081 24.2512V3.90588C32.8081 3.24076 32.2739 2.70012 31.6166 2.70012H8.38344C7.72615 2.70012 7.19188 3.24076 7.19188 3.90588V36.0942C7.19188 36.7593 7.72615 37.2999 8.38344 37.2999H29.3257C29.5172 37.2999 29.6716 37.4562 29.6716 37.6499C29.6716 37.8437 29.518 38 29.3265 38Z",
    fill: "#F4F4F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9326 8.8675C21.9326 9.89889 21.0965 10.735 20.0651 10.735C19.0337 10.735 18.1976 9.89889 18.1976 8.8675C18.1976 7.83611 19.0337 7 20.0651 7C21.0965 7 21.9326 7.83611 21.9326 8.8675Z",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    stroke: "#F4F4F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0394 12.2721C23.5343 12.2721 24.4364 14.5701 24.6693 15.7565C24.7439 16.136 24.3669 16.4475 23.8938 16.4475H16.185C15.7119 16.4475 15.335 16.136 15.4095 15.7565C15.6423 14.5701 16.5445 12.2721 20.0394 12.2721Z",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    stroke: "#F4F4F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdviserReports);
export default __webpack_public_path__ + "static/media/AdviserReports.96e7d03337bc0a324fc8541e62e85fcb.svg";
export { ForwardRef as ReactComponent };